export default __webpack_public_path__ + "static/media/IC00025-events.26368e18.svg";